import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Zoomg = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M12.3 4.396c-.331-.575-.689-1.192-.913-1.583a.025.025 0 0 0-.022-.012H3.527a2.17 2.17 0 0 0-1.876 1.082L0 6.741h7.587l-5.444 9.43a2.163 2.163 0 0 0 0 2.164l1.652 2.86h4.55l-1.648-2.86a2.168 2.168 0 0 1 0-2.164l5.606-9.713c.369-.64.369-1.427 0-2.066l-.002.004z" />
      <path d="M20.812 21.198H9.938a.026.026 0 0 1-.022-.014c-.508-.88-1.094-1.891-1.644-2.847a2.168 2.168 0 0 1 0-2.165L15.97 2.84c.01-.016.034-.018.044 0l1.629 2.824c.386.668.384 1.49 0 2.16l-5.444 9.433h7.54c.02 0 .033-.022.023-.039l-2.253-3.903h4.536c.008 0 .016.005.022.014.507.878 1.094 1.895 1.643 2.85a2.167 2.167 0 0 1 0 2.166l-1.025 1.773A2.17 2.17 0 0 1 20.81 21.2l.003-.002z" />
    </svg>
  );
};

Zoomg.displayName = 'Zoomg';
